import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material';
import { Undo as UndoIcon } from '@mui/icons-material';
import { formatNumber } from '../utils/helpers';

const DialogConfirmacionDesconciliacion = ({
  open,
  onClose,
  onConfirm,
  item,
  updating,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <UndoIcon sx={{ color: '#ed6c02' }} />
        Confirmar Desconciliación
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          ¿Estás seguro que deseas quitar la conciliación de este pago? Volverá a figurar como pendiente.
        </DialogContentText>

        {item && (
          <Box
            sx={{
              mt: 2,
              p: 2,
              border: '1px solid #e0e0e0',
              borderRadius: 1,
            }}
          >
            {item.pedido && (
              <Typography variant="body2">
                <strong>Pedido:</strong> {item.pedido}
              </Typography>
            )}
            {item.cliente && (
              <Typography variant="caption" color="textSecondary" component="div">
                {item.cliente}
              </Typography>
            )}
            {item.monto !== undefined && (
              <Typography variant="body2" sx={{ fontWeight: 600, mt: 0.5 }}>
                ${formatNumber(item.monto)}
              </Typography>
            )}
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          onClick={onClose}
          disabled={updating}
          variant="outlined"
          color="error"
        >
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="warning"
          disabled={updating || !item}
          startIcon={updating ? <CircularProgress size={20} color="inherit" /> : <UndoIcon />}
        >
          {updating ? 'Desconciliando...' : 'Confirmar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirmacionDesconciliacion;
